/** Shell and sign-in copy. English only; one strings file per area keeps a later i18n pass mechanical. */
export const strings = {
  appName: "Helmr",
  signIn: {
    title: "Sign in to Helmr",
    intro: "Enter the mobile number your gym has on file for you. We will send a 6-digit code.",
    phoneLabel: "Mobile number",
    phonePlaceholder: "98765 43210",
    sendCode: "Send code",
    sending: "Sending…",
    codeTitle: "Enter the code",
    codeIntro: (phone: string) => `We sent a 6-digit code to ${phone}.`,
    codeLabel: (n: number) => `Digit ${n} of 6`,
    verify: "Verify",
    verifying: "Checking…",
    trust: "Trust this device",
    resend: "Send a new code",
    resendIn: (s: number) => `Send a new code in ${s}s`,
    changeNumber: "Use a different number",
    businessTitle: "Choose a gym",
    branchTitle: "Choose a branch",
    branchIntro: (business: string) => `Which branch of ${business} are you working at?`,
    picker: {
      gymTitle: "Choose a gym",
      signedInAs: (phone: string) => `Signed in as ${phone}`,
      useAnotherNumber: "Use another number",
      lastUsed: "Last used",
      allGyms: "← All gyms",
      more: (n: number) => `+${n} more`,
      branchCount: (n: number) => `${n} ${n === 1 ? "branch" : "branches"}`,
      searchLabel: "Search gyms",
      searchPlaceholder: "Search gyms",
      noMatch: (q: string) => `No gym matches “${q}”`,
      opening: "Opening",
    },
    staffOnlyTitle: "This app is for gym staff",
    staffOnlyBody: "Your number is registered as a member, not as staff. Ask the gym to add you as staff, or use the member app.",
    signOut: "Sign out",
    errors: {
      phone: "Enter a valid mobile number.",
      codeFormat: "Enter all 6 digits.",
      wrong: "That code is not right. Check it and try again.",
      expired: "That code has expired. Send a new one.",
      rateLimited: (wait: string) => `Too many tries. Try again in ${wait}.`,
      offline: "You appear to be offline. Check your connection and try again.",
      generic: "Something went wrong. Try again.",
      noAccess: "You do not have access to that business or branch.",
    },
  },
  shell: {
    skip: "Skip to content",
    openNav: "Open navigation",
    closeNav: "Close navigation",
    search: "Search",
    searchPlaceholder: "Search members, leads",
    searchLong: "Search members, leads and pages",
    notifications: "Notifications",
    notificationsEmptyTitle: "Notifications are coming",
    notificationsEmptyBody: "Payments, new leads and reader alerts will show up here.",
    account: "Account",
    profile: "Your profile",
    profileSoon: "Coming soon",
    signOut: "Sign out",
    signOutEverywhere: "Sign out everywhere",
    signOutEverywhereRefused: "Not available on a front-desk session.",
    signOutEverywhereFailed: "Could not sign out everywhere. Your other devices are still signed in. Try again.",
    branches: "Branches",
    allBranches: "All branches",
    switchBusiness: "Switch business",
    switchLabel: (current: string) => `Switch branch, current ${current}`,
    switchFailed: "Could not switch. Try again.",
    pages: "Pages",
    members: "Members",
    leads: "Leads",
    noResults: "No results",
  },
  states: {
    noAccessTitle: "You don't have access to this",
    noAccessBody: "Your role does not include this section. Ask the owner if you need it.",
    notConnectedTitle: "Not connected yet",
    notConnectedBody: (what: string) => `${what} will show here once it is connected.`,
    retry: "Retry",
    notFoundTitle: "Page not found",
    notFoundBody: "That page does not exist.",
    backHome: "Back to Home",
    crashTitle: "Something broke on this screen",
    crashBody: "Reload the page. If it keeps happening, tell your gym owner.",
    reload: "Reload",
  },
} as const;
